export default __webpack_public_path__ + "static/media/outlook.2744f5c0.svg";